import appConfig from "app/config/appConfig"
import React from "react"

export const useProgram = () => {
  const [program, setProgram] = React.useState(appConfig.program)

  React.useEffect(() => {
    if (localStorage.getItem("program")) {
      setProgram(localStorage.getItem("program"))
    }
  }, [])

  return program;
}